import {Button} from '@mui/material';
import React from 'react';

import {ContentState} from 'presentation/components';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useContractStatus} from 'presentation/hooks';
import {useAccountInformation, useHandleNewAppointment} from 'presentation/pages';

const {emptyAppointment, newAppointment} = translations['pt-br'].privateFlow.myAppointments;

export function MyAppointmentsHistoryDetailsError() {
	const {isValid, isContractSuspended} = useContractStatus();
	const {odontoOnly} = useAccountInformation();
	const {handleNewAppointment} = useHandleNewAppointment();

	const errorStateDescription = () => {
		if (!isValid) return undefined;

		return odontoOnly ? emptyAppointment.descriptionOdonto : emptyAppointment.description;
	};

	return (
		<ContentState
			description={errorStateDescription()}
			title={emptyAppointment.titleHistory}
			customIconName="calendar-alert"
			footer={
				isValid && !isContractSuspended ? (
					<Button
						endIcon={<Icon name="event-filled" />}
						onClick={handleNewAppointment}
						variant="contained"
						size="large">
						{newAppointment}
					</Button>
				) : null
			}
		/>
	);
}
